/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_One_SecondInputs */



/**
* | output |
* | --- |
* | "Reverse 1 Second" |
*
* @param {Shortcut_Keys_Name_Reverse_One_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_one_second = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_One_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_One_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer d'une seconde")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rückwärts 1 Sekunde")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indietro di 1 secondo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Реверс 1 секунда")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retroceder 1 segundo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("倒退 1 秒")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒巻き戻し")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1 सेकंड पीछे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inverter 1 segundo")
	return /** @type {LocalizedString} */ ("Reverse 1 Second")
});